// extracted by mini-css-extract-plugin
export default {"bodyFreeze":"Modal-module__bodyFreeze___HO7Ce"};